'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const context = createContext(false);
const dispatchContext = createContext(() => { });
export function useSticky() {
    return useContext(context);
}
export function useOnChangeSticky() {
    return useContext(dispatchContext);
}
export function useStickyContext() {
    return {
        sticky: useContext(context),
        onChangeSticky: useContext(dispatchContext),
    };
}
export default function StickyProvider({ children }) {
    const [sticky, setSticky] = useState(true);
    return (_jsx(context.Provider, { value: sticky, children: _jsx(dispatchContext.Provider, { value: setSticky, children: children }) }));
}
